module.exports = __webpack_public_path__ + "static/media/brak_reklam.8debb08f.svg";